export default "__VITE_ASSET__s_M9LcZD__"